import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const sampleData = [
  { name: 'Ops', value: 12 },
  { name: 'Fleet', value: 8 },
  { name: 'Safety', value: 5 },
  { name: 'Pay', value: 10 },
];

export default function ChartCheck() {
  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.textMuted, marginBottom: 12 }}>
        Package-managed chart check
      </div>
      <div style={{ width: '100%', height: 220 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={sampleData}>
            <CartesianGrid stroke={C.borderSoft} vertical={false} />
            <XAxis dataKey="name" stroke={C.textMuted} tickLine={false} axisLine={false} />
            <YAxis stroke={C.textMuted} tickLine={false} axisLine={false} />
            <Tooltip />
            <Bar dataKey="value" fill={C.gold} radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
